import { Button } from '@mui/material';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import { useNavigate } from 'react-router-dom';

export default function GoToDashboardButton() {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      startIcon={<DashboardRoundedIcon />}
      onClick={() => navigate('/apps/tools-dashboard')}
      sx={{
        mb: 2,
        alignSelf: 'flex-end',
        fontWeight: 'bold'
      }}
    >
      Ir al Dashboard
    </Button>
  );
}
